import axios from "axios";

const fetchApi = async (method, url, options = {}) => {
  try {
    const response = await axios({
      method,
      url,
      ...options,
    });
    return response.data;
  } catch (error) {
    // if (error.response.status === 401) {
    //   localStorage.removeItem("token");
    //   toastify(`لطفا مجدد لاگین کنید!`, "info", toast.POSITION.TOP_CENTER);
    //   setTimeout(() => {
    //     window.location.replace(`${process.env.REACT_APP_GOG_URL}`);
    //   }, 500);
    // }
    // Console error
    // console.error("API request error: ", error);

    // #region =====> Global Error Handling
    // if (error.response.status === 406) {
    //   toastify(
    //     "شما در محل برگزاری رویداد حضور ندارید! ",
    //     "error",
    //     toast.POSITION.TOP_CENTER
    //   );
    // } else if (error.response.status === 401) {
    //   localStorage.removeItem("token");
    //   toastify(`لطفا مجدد لاگین کنید!`, "info", toast.POSITION.TOP_CENTER);
    //   // window.location.replace(
    //   //   `${process.env.REACT_APP_GOG_URL}/?login=true&redirect=${window.location.pathname}`
    //   // );
    // } else if (error.response.status === 402) {
    //   toastify(
    //     `درحال انتقال به درگاه پرداخت!`,
    //     "info",
    //     toast.POSITION.TOP_CENTER
    //   );
    //   setTimeout(() => {
    //     window.location.href = error.response.data.data;
    //   }, 1000);
    // } else {
    //   toastify(
    //     `${error.response.data.error}`,
    //     "error",
    //     toast.POSITION.TOP_CENTER
    //   );
    // }
    // #endregion
    throw error;
  }
};
export default fetchApi;
